export const WELCOME_MESSAGE =
    'Hello! I am Sograd, Dragos distant cousin and part-time OTA Assistant. I can help you with questions about MDM, campaigns, device logs, and more. How can I assist you today?';

export const RECOVERY_MESSAGE =
    'Unfortunately, I do not have information on that subject at the moment. Please reach out to the team on the #mdmsupport Slack channel for further assistance.';
